export default "__VITE_ASSET__DTKFk3oF__"